import {
  Grid,
  Paper,
  Typography
} from "@mui/material";
import StatusBadge from "./StatusBadge";

const DetailGrid = ({
  badgeState = "unchecked",
  disableBadge = false,
  PaperProps = {},
  columns
}) => {
  const columnXs = columns.length >= 12 ? 1 : (12 / columns.length)

  return (
    <Grid item xs={12}>
      <Paper
        sx={{
          display: "flex", flexDirection: "column", backgroundColor: "#f5f5f5",
          p: 1.25, borderRadius: 1.25
        }}
        elevation={0}
        {...PaperProps}
      >
        {!disableBadge && <StatusBadge label="Configuration Status" state={badgeState} />}
        <Grid container item>
          {columns.map(({ title, description }) => (
            <Grid item key={title} xs={columnXs}>
              <Typography variant="subtitle1" sx={{ flexDirection: "row", color: "rgb(0,0,0,0.60)" }}>
                {title}
              </Typography>
              <Typography component="div" variant="body2" sx={{ flexDirection: "row" }}>
                {description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Grid>
  )
}

export default DetailGrid;
